import { render, staticRenderFns } from "./ArchiveDocumentManual.vue?vue&type=template&id=1f1da17c&"
import script from "./ArchiveDocumentManual.vue?vue&type=script&lang=js&"
export * from "./ArchiveDocumentManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports